import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ErrorHandler, NgModule } from "@angular/core";
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from "./shared.module";
import { MyErrorHandler } from "./MyErrorHandler";
import { AppComponent } from './app.component';
import { TranslationProvider } from '../providers/translation/translation';
import { AppcacheManagerProvider } from '../providers/appcache-manager/appcache-manager';
import { NgxCurrencyModule } from "ngx-currency";

import { OverviewComponent } from './overview/overview.component';
import { ProfileComponent } from './profile/profile.component';
import { TipsComponent } from './tips/tips.component';
import { RankingComponent } from './ranking/ranking.component';
import { LoginPage } from './login/login';
import { FormsModule } from '@angular/forms';
import { LoginPageModule } from './login/login.module';
import { CommonModule, LocationStrategy, HashLocationStrategy } from '@angular/common';
import { OverviewModule } from './overview/overview.module';
import { CampaignsComponent } from './campaigns/campaigns.component';
import { NewSpotComponent } from './newspot/newspot.component';
import { AppService } from './app.service';
import { NewspotImagesComponent } from './newspot-images/newspot-images.component';
import { NewspotSurveyComponent } from './newspot-survey/newspot-survey.component';
import { NewspotProductsComponent } from './newspot-products/newspot-products.component';
import { NewposComponent } from './newpos/newpos.component';
import { SearchposComponent } from './searchpos/searchpos.component';
import { SearchposModule } from './searchpos/searchpos.module';
import { NewposModule } from './newpos/newpos.module';
import { NewspotSuccessComponent } from './newspot-success/newspot-success.component';
import { AuthGuardService } from './auth.service';
import { NewspotModule } from './newspot/newspot.module';
import { NewspotErrorComponent } from './newspot-error/newspot-error.component';
import { ImageResizeProvider } from 'providers/image-processor/image-resize';
import { ImageProcessorProvider } from 'providers/image-processor/image-processor';
import { LoginRequestComponent } from './login-request/login-request.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { CookieService } from 'ngx-cookie-service';

const appRoutes: Routes = [
    { path: '', redirectTo: '/home', pathMatch: 'full' },
    { path: 'login', component: LoginPage, data: { title: 'Login', show: false } },
    { path: 'home', component: OverviewComponent, data: { title: 'Home' }, canActivate: [AuthGuardService] },
    { path: 'login-request', component: LoginRequestComponent, data: { title: 'Login Request', show: false } },
    { path: 'forgot-password', component: ForgotPasswordComponent, data: { title: 'Forgot Password', show: false } },
    { path: 'profile', component: ProfileComponent, data: { title: 'Profile' }, canActivate: [AuthGuardService] },
    { path: 'tips', component: TipsComponent, data: { title: 'Tips' }, canActivate: [AuthGuardService] },
    { path: 'ranking', component: RankingComponent, data: { title: 'Ranking' }, canActivate: [AuthGuardService] },
    { path: 'ranking/:campaignName/:campaignId', component: RankingComponent, data: { title: 'Ranking', show: false }, canActivate: [AuthGuardService] },
    { path: 'campaigns', component: CampaignsComponent, data: { title: 'Campaigns' }, canActivate: [AuthGuardService] },
    { path: 'newspot', component: NewSpotComponent, data: { title: 'New Check', show: false }, canActivate: [AuthGuardService] },
    { path: 'newspot/images', component: NewspotImagesComponent, data: { title: 'Images', show: false }, canActivate: [AuthGuardService] },
    { path: 'newspot/survey', component: NewspotSurveyComponent, data: { title: 'Survey', show: false }, canActivate: [AuthGuardService] },
    { path: 'newspot/products', component: NewspotProductsComponent, data: { title: 'Products', show: false }, canActivate: [AuthGuardService] },
    { path: 'newspot/success', component: NewspotSuccessComponent, data: { title: 'Success', show: false }, canActivate: [AuthGuardService] },
    { path: 'newspot/error/:statusCode', component: NewspotErrorComponent, data: { title: 'Error', show: false }, canActivate: [AuthGuardService] },
    { path: 'searchpos', component: SearchposComponent, data: { title: 'Search Pos', show: false }, canActivate: [AuthGuardService] },
    { path: 'newpos', component: NewposComponent, data: { title: 'New Pos', show: false }, canActivate: [AuthGuardService] },
];


@NgModule({
    declarations: [
        AppComponent,
        ProfileComponent,
        TipsComponent,
        RankingComponent,
        CampaignsComponent,
        LoginRequestComponent,
        ForgotPasswordComponent,
    ],
    imports: [
        SearchposModule,
        NewposModule,
        SharedModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        NewspotModule,
        LoginPageModule,
        OverviewModule,
        RouterModule.forRoot(appRoutes, {
            useHash: true,
            scrollPositionRestoration: 'enabled' 
        })
    ],
    providers: [
        //{ provide: ErrorHandler, useClass: MyErrorHandler },
        AppService,
        TranslationProvider,
        AppcacheManagerProvider,
        ImageResizeProvider,
        ImageProcessorProvider,
        CookieService, 
        AuthGuardService],
    bootstrap: [AppComponent]
})
export class AppModule {
}
